import React from 'react';
import styled from 'styled-components';
import { ReactComponent as VerifiedIcon } from '../../../../assets/images/verified.svg';

const StyledLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.3rem 1rem 0.75rem 1rem;
  font-size: 0.875rem;
  font-weight: 400;
  color: #232323;
`;

type Props = {
  text?: string;
};

export function VerifiedResidentsLabel({ text = 'Verified residents' }: Props) {
  return (
    <StyledLabel>
      <VerifiedIcon />
      {text}
    </StyledLabel>
  );
}
